<template>
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" :rules="rules" label-width="200px">
      <div class="common-form">提现设置</div>
      <el-form-item label="是否开启提现">
        <el-radio-group v-model="form.is_open">
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="微信提现方式">
        <el-radio-group v-model="form.wechat_type">
          <el-radio label="0">微信提现到零钱</el-radio>
          <el-radio label="1">商家转账到零钱</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="提现手续费比例" prop="cash_ratio">
        <el-input v-model="form.cash_ratio" class="max-w460"><template slot="append">%</template></el-input>
      </el-form-item>
      <el-form-item label="最低提现金额" prop="min_money">
        <el-input v-model="form.min_money" class="max-w460"><template slot="append">元</template></el-input>
      </el-form-item>
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" :loading="loading" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import BalanceApi from '@/api/balance.js'
export default {
  data() {
    return {
      form: {},
      loading: false,
      rules: {
        cash_ratio: [{ required: true, message: ' ' }],
        min_money: [{ required: true, message: ' ' }]
      }
    }
  },
  created() {
    BalanceApi.getCashSetting({}, true).then(d => { this.form = d.data.values }).catch(() => {})
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(ok => {
        if (!ok) return
        this.loading = true
        BalanceApi.cashSetting(this.form, true).then(d => {
          this.loading = false
          if (d.code === 1) this.$message.success('保存成功')
        }).catch(() => { this.loading = false })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/distribution/cashsetting.vue